var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoTranslater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 19,
    viewBox: "0 0 8 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.90954 3.90884C2.88822 3.90884 2.06028 3.0809 2.06028 2.05958C2.06028 1.03827 2.88822 0.210327 3.90954 0.210327C4.93085 0.210327 5.75879 1.03827 5.75879 2.05958C5.75879 3.0809 4.93085 3.90884 3.90954 3.90884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.38554e-05 7.19468V4.76227H7.81934V7.19468H5.78215V16.532H7.81934V18.9644H-3.38554e-05V16.532H2.03715V7.19468H-3.38554e-05Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.81937,
    height: 18.7541,
    fill: "white",
    transform: "matrix(-1 0 0 1 7.81934 0.210327)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoTranslater);
export default __webpack_public_path__ + "static/media/info-translater.6095d6cd6a3d828098e57a4cec86ba46.svg";
export { ForwardRef as ReactComponent };